import type { HostingServerView } from '@tosho/contracts';
import { PrototypeIcon } from './PrototypeIcon';
import { declaredHostingPanels } from './hosting-technology-catalogue';

function usesPlesk(server: HostingServerView): boolean {
  return (
    server.administration === 'ORGANIZATION' &&
    declaredHostingPanels(server).some((panel) => panel.kind === 'PLESK' && panel.present === true)
  );
}
/** Un constat daté ; masquer le succès redondant ne masque pas un accès devenu historique. */
export function HostingServerPleskStatus({
  server,
}: {
  readonly server: HostingServerView;
}): React.JSX.Element | null {
  const observation = server.pleskInventory;
  if (server.administration !== 'ORGANIZATION')
    return <small>Hébergement externe · descriptif uniquement</small>;
  if (!usesPlesk(server)) return null;
  return (
    <div className="hosting-server-status">
      {observation ? (
        <>
          {!observation.accessIsCurrent && (
            <span className="hosting-server-status__badge">
              <PrototypeIcon name="history" /> Accès changé · lecture à renouveler
            </span>
          )}
          <small>
            Dernier inventaire : {new Date(observation.observedAt).toLocaleString('fr-FR')}
          </small>
          {observation.accessIsCurrent && (
            <a
              className="hosting-server-status__open"
              href={'/api/hosting-servers/' + encodeURIComponent(server.id) + '/plesk-access/open'}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={'Aller sur le serveur — ' + server.label + ' (nouvel onglet)'}
            >
              Aller sur le serveur <PrototypeIcon name="arrow-right" />
            </a>
          )}
        </>
      ) : (
        <span className="hosting-server-status__badge">
          <PrototypeIcon name="circle-help" /> Inventaire Plesk à effectuer
        </span>
      )}
    </div>
  );
}
/** Un seul aperçu, même pour consulter un inventaire devenu historique. */
export function HostingServerSitesButton({
  server,
  onSites,
}: {
  readonly server: HostingServerView;
  readonly onSites: () => void;
}): React.JSX.Element | null {
  const observation = server.pleskInventory;
  const count =
    (usesPlesk(server) && observation ? observation.domainCount : 0) +
    (server.declaredSiteCount ?? 0);
  if (
    server.administration !== 'ORGANIZATION' ||
    (count === 0 && !(usesPlesk(server) && observation))
  )
    return null;
  return (
    <button
      type="button"
      id={'hosting-sites-' + server.id}
      className="hosting-server-status__sites hosting-servers__primary"
      onClick={onSites}
      aria-label={'Voir les ' + count + ' sites liés de ' + server.label}
    >
      <PrototypeIcon name="eye" /> {count} site
      {count > 1 ? 's' : ''} lié{count > 1 ? 's' : ''}
    </button>
  );
}
